import React from "react";
import "./BookingThree.css";

interface ButtonThreeProps {
  text?: string;
  icon?: React.ReactNode; // optional icon
  image?: string; // optional image url
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  width?: string;
  borderRadius?: string;
  bgColor?: string;
  color?: string;
  iconPosition?: "left" | "right";
  marginTop?: string; // <-- add this line
  disabled?: boolean;
}

const ButtonThree: React.FC<ButtonThreeProps> = ({
  text = "Proceed with payment",
  icon,
  image,
  onClick,
  type = "button",
  width,
  borderRadius,
  bgColor,
  color,
  iconPosition = "left", // default to left
  marginTop, // <-- add this line
  disabled = false,
}) => (
  <button
    type={type}
    disabled={disabled}
    className="booking-form-submit-btn three"
    onClick={onClick}
    style={{
      ...(width ? { width } : {}),
      ...(borderRadius ? { borderRadius } : {}),
      ...(bgColor ? { backgroundColor: bgColor } : {}),
      ...(color ? { color } : {}),
      ...(marginTop ? { marginTop } : {}), // <-- add this line
    }}
  >
    {/* Icon or image on the left */}
    {iconPosition === "left" && (
      <>
        {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
        {!icon && image && (
          <img
            src={image}
            alt="icon"
            style={{
              marginRight: 8,
              width: 15,
              height: 15,
              objectFit: "contain",
            }}
          />
        )}
      </>
    )}
    {text}
    {/* Icon or image on the right */}
    {iconPosition === "right" && (
      <>
        {icon && <span style={{ marginLeft: 8 }}>{icon}</span>}
        {!icon && image && (
          <img
            src={image}
            alt="icon"
            style={{
              marginLeft: 8,
              width: 20,
              height: 20,
              objectFit: "contain",
            }}
          />
        )}
      </>
    )}
  </button>
);

export default ButtonThree;
